var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.activeModal === 1)?_c('app-screen-email-modal'):_vm._e(),_vm._v(" "),_c('app-language-list'),_vm._v(" "),_c('div',{staticClass:"page-container"},[_c('transition',{attrs:{"name":"slide","mode":"out-in"}},[_c('keep-alive',[_c(_vm.appPage,{tag:"component"})],1)],1)],1),_vm._v(" "),_c('app-navigation')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5692547d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 42
// module chunks = 0